module.exports = __webpack_public_path__ + "img/img_foot_R.9c04a745.svg";